import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import { useController } from 'react-hook-form';

const propTypes = {
  label: PropTypes.string,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  errorMessage: PropTypes.string,
  control: PropTypes.shape({}),
};
const defaultProps = {
  type: 'text',
  disabled: false,
  placeholder: '',
  className: '',
  label: '',
  errorMessage: '',
  control: {},
};

export function Input(props) {
  const { label, type, name, disabled, placeholder, className, control } =
    props;
  const { field, formState } = useController(props);
  const breakdownName = (n) => n.replace(']', '').split('[');

  const getFieldState = (obj) => {
    let result = null;
    if (obj) {
      const pName = breakdownName(name);
      if (pName.length > 0) {
        if (obj.errors[pName[0]]) {
          if (pName.length > 1) {
            result = obj.errors[pName[0]][pName[1]];
            return result;
          }

          result = obj.errors[pName[0]];
        }
      }
    }

    return result;
  };

  const hasErrors = () => {
    let result;
    const fieldState = getFieldState(formState);
    if (fieldState) {
      result = !!Object.keys(fieldState).length;
    }

    return result;
  };

  const renderInput = () => (
    <input
      {...field}
      type={type}
      className={classNames(className, 'form-control', {
        'is-invalid': hasErrors(),
      })}
      // eslint-disable-next-line react/prop-types
      required={!!control?.required}
      id={name}
      name={name}
      disabled={disabled}
      placeholder={placeholder}
    />
  );

  return (
    <div className="form input">
      {label.length > 0 ? (
        <Row className={className}>
          <Col sm={12} xl={3} md={3} className="label-container">
            <label htmlFor={name} className="col-form-label">
              {label}
            </label>
          </Col>
          <Col sm={12} xl={9} md={9} className="field-container">
            {renderInput()}
            <div
              className={classNames('invalid-feedback', {
                show: hasErrors(),
              })}
            >
              {formState.errors[name]?.type === 'required' &&
                `${label} is required`}
            </div>
          </Col>
        </Row>
      ) : (
        <div className={className}>
          {renderInput()}
          <div
            className={classNames('invalid-feedback', {
              show: hasErrors(),
            })}
          >
            {formState.errors[name]?.type === 'required' &&
              `${placeholder} is required`}
          </div>
        </div>
      )}
    </div>
  );
}

Input.propTypes = propTypes;
Input.defaultProps = defaultProps;
